export default __webpack_public_path__ + "static/media/A9204772_tn.0bbc2858.jpg";